export const API_PREFIX = "/api/v1" as const;

export const endpoints = {
  health: "/health",
  auth: {
    csrf: `${API_PREFIX}/auth/csrf`,
    login: `${API_PREFIX}/auth/login`,
    logout: `${API_PREFIX}/auth/logout`,
    me: `${API_PREFIX}/auth/me`,
  },
  dashboard: `${API_PREFIX}/dashboard/summary`,
  search: `${API_PREFIX}/search`,
  tasks: `${API_PREFIX}/tasks`,
  notes: `${API_PREFIX}/notes`,
  tools: `${API_PREFIX}/tools`,
  purchases: `${API_PREFIX}/purchases`,
  purchasesSummary: `${API_PREFIX}/purchases/summary`,
  learningProjects: `${API_PREFIX}/learning-projects`,
  memoryCards: `${API_PREFIX}/memory-cards`,
  memories: `${API_PREFIX}/memories`,
  agentAccess: `${API_PREFIX}/agent-tokens`,
  dailyReviews: `${API_PREFIX}/daily-reviews`,
  tags: `${API_PREFIX}/tags`,
  data: {
    exportJson: `${API_PREFIX}/data/export/json`,
    exportNotesMarkdown: `${API_PREFIX}/data/export/notes.md`,
    importPreview: `${API_PREFIX}/data/import/preview`,
    importCommit: `${API_PREFIX}/data/import`,
  },
} as const;

export const entityEndpoint = (collection: string, id: string) => `${API_PREFIX}/${collection}/${encodeURIComponent(id)}`;
